import LandingLayout from "components/common/landingLayout";
import Imprint from "components/imprint";
import React from "react";

const ImprintPage = () => {
  return (
    <LandingLayout>
      <Imprint />
    </LandingLayout>
  );
};
export default ImprintPage;
